// extracted by mini-css-extract-plugin
export default {"container":"Orders_container__AWsZN","header":"Orders_header__yS-JV","buttonWrapper":"Orders_buttonWrapper__CQ1q9","content":"Orders_content__KI0FS","switch":"Orders_switch__-LGnz"};